<div class="flex place-content-between px-4 py-6 text-xl leading-6 hover:bg-gray-200">
  <span><ng-content /></span>
  <span>></span>
</div>
<div class="mx-4 border-b border-[#D3D8EF] opacity-50"></div>
